import { jsx } from 'react/jsx-runtime';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: "grid",
      gridTemplateAreas: "'pageHeader pageHeader pageHeader' 'pageSubheader pageSubheader pageSubheader' 'pageNav pageContent pageSidebar'",
      gridTemplateRows: "max-content auto 1fr",
      gridTemplateColumns: "auto 1fr auto",
      overflowY: "auto",
      height: "100vh",
      [theme.breakpoints.down("xs")]: {
        height: "100%"
      },
      "@media print": {
        display: "block",
        height: "auto",
        overflowY: "inherit"
      }
    }
  }),
  { name: "BackstagePage" }
);
function Page(props) {
  const { themeId, className, children } = props;
  const classes = useStyles();
  return /* @__PURE__ */ jsx(
    ThemeProvider,
    {
      theme: (baseTheme) => ({
        ...baseTheme,
        page: baseTheme.getPageTheme({ themeId })
      }),
      children: /* @__PURE__ */ jsx("main", { className: classNames(classes.root, className), children })
    }
  );
}

export { Page };
//# sourceMappingURL=Page.esm.js.map
